import styled from "styled-components";
import { ButtonProps } from "./types";

export const StyledButton = styled.button<ButtonProps>`
  width: 100%;
  height: 40px;
  margin: 2px;
  cursor: pointer;
  border-radius: 2px;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  padding: 1px 6px;  
  box-sizing: border-box;
  transition: background-color 0.1s linear, border-color 0.1s linear;
  float: right;
  outline: 0;

  &.primary {
    background-color: var(--color-action-default) !important;
    color: var(--color-contrast-brand) !important;
    border: none;
    color: var(--color-contrast-white) !important;

    &:hover {
      background-color: var(--color-action-hover) !important;
      color: var(--color-contrast-brand) !important;
    }

    &:disabled {
      opacity: .5;
      cursor: not-allowed;
    }
  }

  &.danger {
    background-color: var(--color-feedback-danger-300);
    color: var(--color-contrast-white);
    border: none;

    &:hover {
      background-color: #eb140c !important;
    }

    &:disabled {
      background-color: rgba(211, 97, 97, 0.59);
      box-shadow: none;
    }
  }

  &.secondary {
    background-color: var(--color-opacity-default) !important;
    color: var(--color-neutral-600) !important;
    border: var(--border-width-default) solid var(--color-neutral-600) !important;

    &:hover, &:active {
      &:not(:disabled) {
        background-color: var(--color-opacity-hover) !important;
      }
    }
  }

  &.tertiary {
    background-color: var(--color-neutral-100);
    color: #496072;;
    border: solid 1px #c5d0e1;
          
    &:hover {
      background-color: #f4f5f8;
      border: solid 1px #c5d0e1;
    }

     &:disabled {
      background-color: var(--color-neutral-200);
      color: var(--color-neutral-300);
      border: solid 1px var(--color-neutral-200);
      cursor: not-allowed;
    }
  }

  &.hidden {
    background-color: transparent;
    color: var(--color-neutral-600);
    border: none;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04) !important;
    }
  }

  &.default {
    background-color: var(--color-opacity-default) !important;
    color: var(--color-neutral-600) !important;
    border: var(--border-width-default) solid var(--color-neutral-600) !important;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04) !important;
    }

    &:disabled {
      opacity: .5;
      cursor: not-allowed;
    }
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
`;
